// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"b33f6e43","160":"f7c7678c","208":"cebbfc06","293":"f336d72c","516":"9a0d896f","519":"b4d0ff0f","917":"c766142e","946":"b3cb2672"}[chunkId] + ".chunk.js";
};